import { TicketDetail } from "./order";
import { TicketStatus } from "../constants/enum.pos";
import { DateTime } from "luxon";

export interface TicketDetailForOrder {
	ticketId: number;
	status: string;
	ownerName: string;
	createdAt: string;
	color: string;
	numberOfGuests: number;
	tableAlias: string[];
}

export interface TicketListView {
	_Id: number;
	ticketId: number; //Ref
	displayId: number; //CHK
	table: string;
	filterValueCreatedAt: Date;
	numberOfGuests: number;
	ownerName: string;
	createdAt: string;
	filterCreateAt: string | "";
	closedAt: string;
	billPrintedByUsers?: string;
	isSettled: boolean;
	isVoided: boolean;
	type: string; // Dine In, Take Out, Vip ...
	typeName: string; // Dine In, Take Out, Vip ...
	ticketStatus: TicketStatus; // Open, Saved, Closed, Bill Printed, ...
	ticketStatusName: string; // Open, Saved, Closed, Bill Printed, ...
	paymentStatus: string; // Open, Paid, Closed
	paymentStatusName: string; // Open, Paid, Closed
	dueAmount: number;
	totalAmount: number;
	selected?: boolean;
	concurrencyStamp?: string;
	invoiceNumber?: string;
	invoiceNumberCancel?: string;
	publishInvoiceStatus?: string; // 0, 1:ERR, 2:OK
	sendInvocieStatus?: string; // 0, 1:Send, 2:OK, 3:Rejected
	sendMailStatus?: string; // 0, 1:ERR, 2:OK
	updateInfoStatus?: string; // 0 ~ 9
	paymentType?: string;
	paymentTypeDisplay: number;
	invoiceAutoNumber?: number;
	cusName?: string;
	cusMail?: string;
	comName?: string;
	cusTaxCode?: string;
	cusAddress?: string;
	publishDate?: string;
	signDate?: string;
	invoiceStatus?: string;
	customerInfoStatus?: string;
	isToday?: boolean;
}

export enum ActionOnTicketInfo {
	Detail,
	Edit,
	Split,
	Void,
	Settle,
	Print,
	ReOpen,
	Publish,
	EditInvoice,
}

export interface DataOnTicketInfo {
	action: ActionOnTicketInfo;
	ticket: TicketListView;
}

export class NumberOfTicketSplit {
	id: number = null;
	name: string = null;
	active: boolean = false;
	isFree: boolean = true;
	hasItem: boolean = false;
	ticketDetail: TicketDetail = new TicketDetail();
}

export class RequestSplitTicket {
	concurrencyStamp: string = null;
	sourceTicketId: number = null;
	data: TicketSplit[] = [];
}

export class TicketSplit {
	tableAlias: string = null;
	items: TicketItemSpit[] = [];
}

export class TicketItemSpit {
	ticketItemId: number = null;
	quantity: number = null;
}

export interface TicketStatusFilter {
	type: string;
	name: string;
	ticketStatus: TicketStatus[];
	active?: boolean;
}
